// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ix-0";